var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Xing = function (_a) {
    var color = _a.color, background = _a.background, props = __rest(_a, ["color", "background"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40" }, props),
        React.createElement("g", { fill: "none" },
            React.createElement("path", { fill: background, className: "ic_background", d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z" }),
            React.createElement("path", { fill: color, className: "ic_filling", d: "M11.003 12.937c-.224 0-.413.076-.508.226-.098.154-.083.352.021.553l2.52 4.22c.005.008.005.013 0 .02l-3.96 6.76c-.104.2-.099.4 0 .554a.554.554 0 0 0 .487.246h3.728c.558 0 .826-.364 1.017-.697l4.025-6.883c-.016-.024-2.563-4.323-2.563-4.323-.186-.32-.466-.676-1.038-.676h-3.729zM26.666 8c-.557 0-.798.34-.998.687l-8.296 14.227 5.297 9.4c.185.319.47.686 1.042.686h3.724c.224 0 .4-.082.494-.23.1-.154.097-.358-.007-.557l-5.256-9.287a.02.02 0 0 1 0-.024L30.92 8.787c.103-.2.105-.403.007-.557-.095-.148-.271-.23-.496-.23h-3.766z" }))));
};
Xing.defaultProps = {
    background: '#555',
    color: '#151515',
};
export default Xing;
//# sourceMappingURL=Xing.js.map